import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { EquipmentPhotoModel, MandatoryEquipmentPhotoModel } from '../../models/rope-shovel.model';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';import { EditPhotoComponent } from '../../../../shared/components/edit-photo/edit-photo.component';
import { RopeShovelService } from '../../rope-shovel.service';
import { NotificationsService } from 'angular2-notifications';
import { DeleteConfirmationDialogComponent } from '../delete-confirmation-dialog/delete-confirmation-dialog.component';

@Component({
  selector: 'equipment-photo',
  templateUrl: './equipment-photo.component.html',
  styleUrls: ['./equipment-photo.component.scss']
})
export class EquipmentPhotoComponent implements OnInit {
  @Input() photo: EquipmentPhotoModel;
  @Input() inspectionId: number;
  @ViewChild('fileInput') fileInput: ElementRef;
  newPhoto: string;
  displayDeleteIcon: boolean = false;

  constructor(private _sanitizer: DomSanitizer,
    public editPhotoComponent: MatDialog,
    public dialog: MatDialog,
    private _service: RopeShovelService,
    private _notify: NotificationsService) { }

  ngOnInit() {
  }

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }

  // onSelectPhoto(event) {
  //   if (event.target.files && event.target.files[0]) {
  //     var reader = new FileReader();

  //     reader.readAsDataURL(event.target.files[0]); // read file as data url

  //     reader.onload = (event: FileReaderEvent) => { // called once readAsDataURL is completed
  //       this.newPhoto = event.target.result;
  //       console.log("Equipment photo",  this.newPhoto)
  //       //resize photo
  //       this.compressImage(this.newPhoto).then((res: string) => {
  //         // console.log("imageUrl", res)
  //         if (res) {
  //          console.log('res_____', res)

  //           //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
  //           this.uploadPhoto(res);
  //          // this.uploadPhoto(this.newPhoto);
  //         }
  //       })
       
  //     }
  //   }
  // }
  onSelectPhoto(event: any) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
  
      reader.readAsDataURL(event.target.files[0]); // read file as data URL
  
      reader.onload = (event: ProgressEvent<FileReader>) => { // called once readAsDataURL is completed
        if (event.target && event.target.result) {
          this.newPhoto = event.target.result as string; // Cast result to string
          console.log("Equipment photo", this.newPhoto);
  
          // Resize photo
          this.compressImage(this.newPhoto).then((res: string) => {
            if (res) {
              console.log('res_____', res);
              // Upload the compressed photo
              this.uploadPhoto(res); 
            }
          });
        }
      };
    }
  }
  
  private compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();




      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');

        let width, height;
        width = img.width;
        height = img.height;

        console.log('width', width)
        console.log('height', height)

        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800;//643
        var new_height = imageWidth * ratio; //calculate new height


        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }

  uploadPhoto(p: string) {
    this._notify.info('Uploading', 'Uploading your photo now...');
    console.log(this.photo);
    let uploadModel = new MandatoryEquipmentPhotoModel(this.inspectionId, this.photo.CustomerModelMandatoryImageId, p, this.photo.Id);
    this._service.uploadEquipmentMandatoryPhoto(uploadModel).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Uploaded', r.m_Item2);
      } else {
        this._notify.error('Failed', r.m_Item2);
        console.log(r);
        this.newPhoto = '';
      }
    }, err => {
      this._notify.error('Failed', 'Unable to upload photo. Please contact TrackTreads support. ');
      console.log(err);
      this.newPhoto = '';
      });
  }

  openEditPhoto() {
    let editPhotoModalRef = this.editPhotoComponent.open(EditPhotoComponent, {
      width: '1024px',
      height: '768px',
      data: { photo: this.photo.Photo }
    });
    editPhotoModalRef.afterClosed().subscribe(res => {
      if (res != null) {
        this.photo.Photo = res.photo;
        this.uploadPhoto(res.photo);
      }
    });
  }

  onMouseEnterPanel(e) {
      this.displayDeleteIcon = true;
  }

  onMouseLeavePanel(e) {
      this.displayDeleteIcon = false;
  }

  checkPermissionToDelete(e) {
      if ((this.photo != null) && (this.photo.Id > 0)) {
          this._service.hasPermissionToDeletePhoto(this.photo.Id).subscribe(r => {
              if (r) {
                  this.showDeletePhotoConfirmationDialog();
              }
          });
      }
  }

  showDeletePhotoConfirmationDialog() {
      let confirmationModalRef = this.dialog.open(DeleteConfirmationDialogComponent, {
          width: '480px',
          height: '240px'
      });
      confirmationModalRef.afterClosed().subscribe(r => {
          if ((r.data != null) && (r.data.goAhead)) {
              this.deletePhoto();
          }
      });
  }

  deletePhoto() {
      if (this.photo.Id > 0) {
          this._service.deleteEquipmentMandatoryPhoto(this.photo.Id).subscribe(r => {
              if (r.m_Item1) {
                  this._notify.success('Deleted Image', r.m_Item2);

                  if (this.newPhoto != null && this.newPhoto != '') {
                      this.newPhoto = '';
                  } else {
                      this.photo.Photo = '';
                  }

              } else {
                  this._notify.error('Failed', r.m_Item2);
              }
          });
      }
  }
}

interface FileReaderEventTarget extends EventTarget {
  result: string
}

interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage(): string;
}
